import { FC } from "react";

import { Phase } from "../models/phase-model";

import { PhaseView } from "./phase-view";
import { PhaseViewEmpty } from "./phase-view-empty";

interface PhaseViewOptionalProps {
  phase?: Phase | null;
  logoOnly?: boolean;
  canTruncateLabel?: boolean;
  className?: string;
}

export const PhaseViewOptional: FC<PhaseViewOptionalProps> = ({ phase, ...props }) => {
  if (!phase) {
    return <PhaseViewEmpty {...props} />;
  }

  return <PhaseView phase={phase} {...props} />;
};
